module.exports = __webpack_public_path__ + "media/images/logo-f95de313987ed983f3349fc90810075f.jpg";